var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalibriteColourCircleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.2 82.2",
    width: 82.2,
    height: 82.2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#40983D",
    d: "M26.6 25.8v30.5c1.5 1.4 3.2 2.6 5.1 3.5V22.3c-1.9 0.9-3.6 2.1-5.1 3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#005FAA",
    d: "M34.5 21.1V61c1.6 0.5 3.3 0.9 5.1 1V20.1c-1.8 0.2-3.5 0.5-5.1 1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BA0A2A",
    d: "M20 41.1c0 4.4 1.4 8.5 3.7 11.9V29.2C21.3 32.6 20 36.7 20 41.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD539",
    d: "M42.4 20.2v9.1c5.8 0.7 10.4 5.7 10.4 11.8s-4.5 11.1-10.4 11.8v9.1c10.9-0.7 19.6-9.8 19.6-20.9s-8.7-20.2-19.6-20.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalibriteColourCircleWhite);
export default __webpack_public_path__ + "static/media/Calibrite-colour-circle_white.219cb4f41302c2b821d2c1048c7e53ae.svg";
export { ForwardRef as ReactComponent };